namespace $ {

	export type $shm_projects_api_project_summary_source = {
		id: string
		title: string
		fqn?: string
		builder?: 'mam' | 'none'
		type?: 'complex' | 'client' | 'server'
		archived?: boolean
		parent_id?: string
		directory_pending?: boolean
		version: string
		version_date: string
		channels?: {
			prerelease?: string
			release?: string
		}
	}

	export type $shm_projects_api_project_summary = Readonly< $shm_projects_api_project_summary_source >

	export function $shm_projects_api_project_summary(
		project: $shm_projects_api_project_summary_source,
	): $shm_projects_api_project_summary {
		return {
			id: project.id,
			title: project.title,
			...( typeof project.fqn === 'string' && project.fqn.trim() ? { fqn: project.fqn.trim() } : {} ),
			...( project.builder ? { builder: project.builder } : {} ),
			...( project.type ? { type: project.type } : {} ),
			...( project.archived !== undefined ? { archived: project.archived } : {} ),
			...( project.parent_id ? { parent_id: project.parent_id } : {} ),
			...( project.directory_pending !== undefined ? { directory_pending: project.directory_pending } : {} ),
			version: project.version,
			version_date: project.version_date,
			...( project.channels ? { channels: project.channels } : {} ),
		}
	}

}
